import type { ChartEmbedSlice } from "~/api/prismic/types"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"

type Props = {
  slice: ChartEmbedSlice
}

const ChartEmbed: React.FC<Props> = ({ slice }) => {
  const { iframe_url, iframe_title } = slice.primary

  return (
    <TailwindProseWrapper className="bg-white">
      <iframe
        title={iframe_title || undefined}
        src={iframe_url}
        className="flourish"
      />
    </TailwindProseWrapper>
  )
}

export default ChartEmbed
